import { m } from 'framer-motion';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { MotionContainer, varBounce } from 'src/components/animate';
import { ForbiddenIllustration } from 'src/assets/illustrations';
import { RouterLink } from 'src/routes/components';
import { getPathAfterLogin } from 'src/layouts/dashboard/config-navigation';

const NotPermissionView = () => (
  <Container component={MotionContainer} sx={{ textAlign: 'center' }}>
    <m.div variants={varBounce().in}>
      <Typography variant="h3" paragraph>
        Permission Denied
      </Typography>
    </m.div>

    <m.div variants={varBounce().in}>
      <Typography sx={{ color: 'text.secondary' }}>
        You do not have permission to access this page
      </Typography>
    </m.div>

    <m.div variants={varBounce().in}>
      <ForbiddenIllustration sx={{ height: 260, my: { xs: 2, sm: 5 } }} />
    </m.div>

    <Button
      component={RouterLink}
      href={getPathAfterLogin() || '/'}
      size="large"
      variant="contained"
    >
      Go to Home
    </Button>
  </Container>
);

export default NotPermissionView;
